import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/**
 * 判断data是否是分组的
 */
export function isGroupData(data) {
  var _data$;

  return data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.data;
}
/**
 * 将分组的data打平，返回选项数组
 */

export function flat(data) {
  var _ref;

  var group = isGroupData(data);
  return group ? (_ref = []).concat.apply(_ref, _toConsumableArray(data.map(function (g) {
    return g.data;
  }))) : data;
}
/**
 * 如果是分组数据，只有一个分组并且该分组没有label，简化为非分组数据
 */

export function simplify(data) {
  if (isGroupData(data) && data.length === 0 && data[0].label) {
    return data[0].data;
  }

  return data;
}